import React from 'react';

const GuitarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M10 4L4.33 19.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12.5 6.5C12.5 6.5 15.5 8 17 11C18.5 14 18 20 18 20C18 20 15 21 13 19.5C11 18 10.5 15.5 10.5 15.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 6.5L14 4" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 15l3-3" />
    <path d="M14 12 a1,1 0 1,0 -2,0 a1,1 0 1,0 2,0" />
  </svg>
);

export default GuitarIcon;
